<template>
    <v-container fluid>
        <v-row class="mb-6">            
                <v-card raised v-for="(area,index) in areas" :key="area.id" class="ms-3 mb-6" min-width="25em">                                        
                        <v-card-title @click="showArea(area)" primary-title class="layout justify-center" :style="getStyle(area.area_color)">{{area.area_name}}</v-card-title>
                        <v-card-text @click="showArea(area)" class="layout justify-center">
                            <v-row>
                                <v-col align="center" justify="center">
                                    <v-img v-if="area.area_icon" :src="area.area_icon" max-width="50" max-height="50" alt=""
                                                                    class="grey lighten-2"
                                                                aspect-ratio="1"
                                                                ></v-img>
                                </v-col>
                                <v-col align="center" justify="center">
                                    <h3>Courses:</h3>
                                    <h2>{{area.number_of_courses}}</h2>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions >                     
                        <div v-if="$store.getters.isAdmin">
                            <p><v-icon class="icon-edit" @click="editArea(area.id)">mdi-pencil</v-icon></p>
                            <p><v-icon class="icon-delete" @click="deleteArea(area.id)" >mdi-delete</v-icon></p>
                            <p><v-icon v-if="index > 0" class="icon-up" @click="moveArea(index, index-1)">mdi-arrow-left</v-icon></p>
                            <p><v-icon v-if="index < areas.length-1" class="icon-down" @click="moveArea(index, index+1)">mdi-arrow-right</v-icon></p>
                        </div>
                    </v-card-actions>
                </v-card>

                <v-card raised v-if="$store.getters.isAdmin" class="mx-auto ml-3 mr-3 mb-6" min-width="15em" >
                    <v-card-text>
                        <v-layout justify-center>
                            <v-icon size="x-large" @click="addArea()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-card-text>  
                </v-card>
        </v-row>
    </v-container>    
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            areas : []
        }
    },
    created() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    
            this.$store.commit('setBcChange',true)
            // get area list
            axios.get('/get-areas/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                this.areas = res.data.areas 
            })
            .catch(error => {
            this.$store.commit('setFeedback', error)          
            })
        },
        addArea() {
            this.$router.push({name:'admin_area', params: {id: '0'}})        
        },
        editArea(id) {
            this.$router.push({name:'admin_area', params: {id: id}})        
        },
        deleteArea(id) {
            this.$store.commit('setFeedback', null)    
            // get category list
            axios.get('/delete-area/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveArea(p1, p2) {
            const data = {
                area_id1: this.areas[p1].id,
                area_order1: this.areas[p1].area_order,
                area_id2: this.areas[p2].id,
                area_order2: this.areas[p2].area_order
            }

            axios.post('/area-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },
      showArea(area) {
          this.$store.dispatch('setActiveArea', {id: area.id, name: area.area_name} )
          this.$router.push({name:'courses', params: {id: area.id}})          
      },
      getStyle(col) {
          return "color: white; background-color: "+col+"; margin-bottom: 0.5em;";
      }

    }
}
</script>

<style>

.icon-edit {
  position: absolute;
  bottom: 4px;
  right: 100px;
  cursor: pointer;
}

.icon-delete {
  position: absolute;
  bottom: 4px;
  right: 68px;
  cursor: pointer;
}

.icon-up {
  position: absolute;
  bottom: 4px;
  right: 36px;
  cursor: pointer;
}

.icon-down {
  position: absolute;
  bottom: 4px;
  right: 4px;
  cursor: pointer;
}
/*
.theme--light.v-card {
  background-color: #FAFAFA;
  color: #00B1B0;
  padding: 5px;
}
.theme--light.v-data-table {
  background-color: #FAFAFA;
}
*/
</style>